export default __webpack_public_path__ + "static/media/Nature.ad0cdddb.svg";